import React, { useState } from 'react';
import { ProfileDropdown } from '../components/profileDropdown/ProfileDropdown/ProfileDropdown';
import { FirmSelectorModal } from '../components/firmDropdown/FirmSelectorModal/FirmSelectorModal';
// import { HeaderSearch } from '../components/HeaderSearch/HeaderSearch';
import { SettingsDropdown } from '../components/settingsDropdown/SettingsDropdown';
import * as S from '../Header.styles';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BankOutlined } from '@ant-design/icons';

interface MobileHeaderProps {
  toggleSider: () => void;
  isSiderOpened: boolean;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({ toggleSider, isSiderOpened }) => {
  const [isFirmModalOpen, setFirmModalOpen] = useState(false);

  return (
    <BaseRow justify="space-between" align="middle">
      <BaseCol>
        <ProfileDropdown />
      </BaseCol>

      <BaseCol>
        <BaseRow align="middle">
          <BaseCol>
            <S.HeaderActionWrapper onClick={() => setFirmModalOpen(true)}>
              <BankOutlined />
            </S.HeaderActionWrapper>
          </BaseCol>

          {/* <BaseCol>
            <NotificationsDropdown />
          </BaseCol> */}

          {/* <BaseCol>
            <HeaderSearch />
          </BaseCol> */}

          <BaseCol>
            <SettingsDropdown />
          </BaseCol>
        </BaseRow>
      </BaseCol>

      <S.BurgerCol>
        <S.MobileBurger onClick={toggleSider} isCross={isSiderOpened} />
      </S.BurgerCol>

      <FirmSelectorModal isOpen={isFirmModalOpen} onClose={() => setFirmModalOpen(false)} />
    </BaseRow>
  );
};
